import React, { useState } from "react";
import { Check, ShieldCheck, X } from "lucide-react";
import { API_BASE } from "../config";
import BrowserLogin from './BrowserLogin';
import BrowserTakeover from './BrowserTakeover';

export default function BrowserApproval({ jobId, approval }) {
  const [sending, setSending] = useState(false);
  const [decision, setDecision] = useState("");
  const [error, setError] = useState("");
  const pending = approval.state === "pending" && !decision;
  const expired = Number(approval.expires_at) * 1000 < Date.now();
  const decide = async approved => {
    setSending(true);
    setError("");
    try {
      const response = await fetch(`${API_BASE}/v1/chat/jobs/${jobId}/browser-approvals/${approval.pending_id}`, {
        method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ approved }),
      });
      if (!response.ok) throw new Error("确认未能提交，操作可能已过期。请刷新进度后重试。");
      setDecision(approved ? "approved" : "denied");
    } catch (err) { setError(err.message); }
    finally { setSending(false); }
  };
  if (['login', 'qr_login'].includes(approval.kind)) return <BrowserLogin jobId={jobId} approval={approval} />;
  if (approval.kind === 'human') return <BrowserTakeover jobId={jobId} approval={approval} />;
  return <div className="browser-approval" role={pending ? "alert" : "status"}>
    <div className="browser-approval-heading"><ShieldCheck size={16} /><strong>{approval.summary}</strong></div>
    <div className="browser-approval-url">{approval.url}</div>
    {approval.text_preview && <blockquote>{approval.text_preview}</blockquote>}
    {pending && !expired ? <div className="browser-approval-actions">
      <button type="button" disabled={sending} onClick={() => decide(false)}><X size={14} />不执行</button>
      <button type="button" disabled={sending} onClick={() => decide(true)}><Check size={14} />允许这一次</button>
    </div> : <span>{(decision || approval.state) === "approved" ? "已确认" : "未执行或确认已过期"}</span>}
    {error && <div role="alert">{error}</div>}
  </div>;
}
